import { StoreSlice } from '../types';

const { REACT_APP_VERSION, REACT_APP_MODE, REACT_APP_NAME } = process.env;

export declare interface IAppSlice {
  [key: string]: unknown, // important! allows for extention outside of typescript slices
  appVersion?: string;
  appMode?: string;
  appName?: string;
  currentPage: number;
  pageTitle: string,
  userId: any;
  foundError: boolean;
  initFocusElement: HTMLButtonElement;
  setPage: (v: number) => void;
  setPageTitle: (v:string) => void,
  setUserId: (v: number) => void;
  setFoundError: (v: boolean) => void;
  currentVolume: number;
  setCurrentVolume: (v: number) => void;
  properOrientationConfirmed: boolean;
  setProperOrientationConfirmed: (v: boolean) => void;
	setInitFocusElement: (v: HTMLButtonElement) => void;
}

const createAppSlice: StoreSlice<IAppSlice> = (set) => ({
  appVersion: REACT_APP_VERSION,
  appMode: REACT_APP_MODE,
  appName: REACT_APP_NAME,
  currentPage: (Number(new URLSearchParams(window.location.search).get('page')) ?? 0),
  pageTitle: '',
  userId: null,
  foundError: false,
  initFocusElement: null,
  currentVolume: 100,
  properOrientationConfirmed: false,
  setPage: (v) => set((state) => { state.currentPage = v; }),
  setPageTitle: (v) => set((state) => { state.pageTitle = v; }),
  setUserId: (v) => set((state) => { state.userId = v; }),
  setFoundError: (v) => set((state) => { state.foundError = v; }),
  setCurrentVolume: (v) => set((state) => { state.currentVolume = v; }),
  setProperOrientationConfirmed: (v) => set((state) => { state.properOrientationConfirmed = v; }),
  setInitFocusElement: (v) =>
  set((state) => {
    state.initFocusElement = v;
  }),
});

export default createAppSlice;
